_ = require 'underscore'
BaseDirectoryView = require './base-directory-view'
DirectoryPluginItemView = require './directory-plugin-item-view'
t = require('views/internal/recup-with-helpers')('directory')
React = require 'react'

class DirectorySearchComponent extends React.Component
  displayName: 'Directory Search'

  render: t.renderable ->
    t.div '.directory-content-body', =>
      if @props.isEmpty
        t.div '.directory-search-empty', =>
          t.p =>
            t.formatText 'bummer-no-search-results-for'
            t.span =>
              t.text '"' + @props.searchTerm + '"'
      else
        t.div '.directory-listing'

module.exports = class DirectorySearchView extends BaseDirectoryView
  renderContent: ->
    React.createElement DirectorySearchComponent, {
      searchTerm: @options.searchTerm
      isEmpty: _.isEmpty @options.plugins
    }

  render: ->
    super
    contentContainer = @$el.find('.directory-listing')
    contentContainer.empty()

    { plugins, currentPage, directoryView } = @options

    pluginViews = _.map plugins, (plugin) =>
      @subview(DirectoryPluginItemView, @model, {
        atomType: 'description'
        currentPage
        plugin
        directoryView
      }, plugin.id)

    @appendSubviews(pluginViews, contentContainer)

    @



// WEBPACK FOOTER //
// ./app/scripts/views/directory/directory-search-view.coffee